import { VStack } from '@chakra-ui/react';

import DimensionSelectionSteps from './selectDimensionTwosteps/DimensionSelectionSteps';

interface Properties {
  getFormValue: any;
}

/**
 * Step that lets the user select dimension columns for data/forecast imports.
 * On Continue, saves the payload to Redux and advances to the Sync Options step
 * (which creates the action and opens the mapping modal).
 */
const SelectDimensionColumn = ({ getFormValue }: Properties) => {
  return (
    <VStack display='flex' justify={'center'} w={'100%'} pt={3}>
      <DimensionSelectionSteps getFormValue={getFormValue} />
    </VStack>
  );
};

export default SelectDimensionColumn;
